module.exports = {"422822100":"业州镇","422822101":"高坪镇","422822102":"红岩寺镇","422822103":"景阳镇","422822104":"官店镇","422822105":"花坪镇","422822106":"长梁镇","422822201":"茅田乡","422822202":"龙坪乡","422822203":"三里乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/422822.json
// module id = 1794
// module chunks = 0